document.addEventListener('DOMContentLoaded', function() {
  // Hàm lấy thông tin biến thể dựa trên variantId
  function getVariantById(variantId) {
    if (typeof meta !== "undefined" && meta.product && meta.product.variants && Array.isArray(meta.product.variants)) {
      return meta.product.variants.find(function(item) {
        return String(item.id) === String(variantId);
      });
    }
    return null;
  }

  // Hàm cập nhật productPrice dựa trên variantId
  function updateProductPriceByVariant(variantId) {
    const matchedVariant = getVariantById(variantId);
    if (matchedVariant) {
      // Chia giá trị price cho 100
      return matchedVariant.price / 100;
    }
    return null;
  }

  // Hàm lấy tên biến thể dựa trên variantId
  function updateProductNameByVariant(variantId) {
    const matchedVariant = getVariantById(variantId);
    if (matchedVariant && matchedVariant.name) {
      return matchedVariant.name;
    }
    return '';
  }

  // Hàm cập nhật giá trị trả góp cho bk-btn-installment
  function updateInstallmentValue(productPrice) {
    const installmentButton = document.querySelector('.bk-btn-installment');
    if (installmentButton && productPrice !== null) {
      // Xóa nội dung cũ
      while (installmentButton.firstChild) {
        installmentButton.removeChild(installmentButton.firstChild);
      }

      const rawValue = productPrice * 1.079 / 12;
      const roundedValue = Math.round(rawValue);
      const formattedValue = roundedValue.toLocaleString('vi-VN');

      // Dòng 1: Không cần trả trước (in đậm)
      const strongEl = document.createElement('div');
      strongEl.textContent = 'TRẢ GÓP QUA THẺ TÍN DỤNG';

           
      const line2 = document.createElement('div');
      line2.classList.add('custom-button-subtitle'); // Thêm class custom-button-subtitle
  
      const spanPrice = document.createElement('span');
      spanPrice.classList.add('price-highlight'); // Thêm class price-highlight
      spanPrice.textContent = formattedValue + 'đ/tháng';
  
      line2.textContent = 'Chỉ từ: ';
      line2.appendChild(spanPrice);

      
      installmentButton.appendChild(strongEl);      
      installmentButton.appendChild(line2);

      
    }
  }

  // Hàm cập nhật nội dung cho bk-insta-content
  function updateInstaContentValue(productPrice) {
    const instaButton = document.querySelector('.bk-insta-content');
    if (instaButton && productPrice !== null) {
      // Xóa nội dung cũ
      while (instaButton.firstChild) {
        instaButton.removeChild(instaButton.firstChild);
      }

      // Z = giá * 0.3
      const Z = Math.round(productPrice * 0.3);
      // Y = giá / 12
      const Y = Math.round(productPrice / 12);

      const ZFormatted = Z.toLocaleString('vi-VN');
      const YFormatted = Y.toLocaleString('vi-VN');

      // Dòng 1: Mua Ngay Trả Sau
      const strongLine1 = document.createElement('div');
      strongLine1.textContent = 'TRẢ GÓP QUA CCCD/BLX';


      // Dòng 2: Trả trước Z với span
      const line2 = document.createElement('div');
      line2.classList.add('custom-button-subtitle'); // Thêm class custom-button-subtitle
  
      const spanPrice = document.createElement('span');
      spanPrice.classList.add('price-highlight'); // Thêm class price-highlight
      spanPrice.textContent = ZFormatted + 'đ';

      const text = document.createTextNode(' & ');
      const spanPrice2 = document.createElement('span');
      spanPrice2.classList.add('price-highlight'); // Thêm class price-highlight
      spanPrice2.textContent = YFormatted + 'đ/tháng';

      line2.textContent = 'Trả trước: ';
      line2.appendChild(spanPrice);
      line2.appendChild(text);
      line2.appendChild(spanPrice2);

      
      instaButton.appendChild(strongLine1);      
      instaButton.appendChild(line2);

    }
  }

  const productPropertyElement = document.querySelector('.bk-product-property');

 document.addEventListener('change', function(event) {
    // Lấy đường đi của sự kiện (composedPath) để kiểm tra shadow DOM và node chứa
    const path = event.composedPath();
    // Kiểm tra xem trong path có phần tử .variant-picker__option không
    const isInVariantPicker = path.some(node => {
      return node instanceof Element && node.closest && node.closest('.variant-picker__option');
    });

    // Nếu sự kiện xảy ra trong .variant-picker__option
   // console.log('Full Path:', path.map(node => node.tagName || node.nodeName));
   // console.log('path',path)
   //  console.log('isInVariantPicker',isInVariantPicker)
    // if (isInVariantPicker) {
      // Khi biến thể thay đổi, sau 200ms ta mới lấy variantIdInput.value để đảm bảo nó cập nhật xong
      setTimeout(function() {
        const variantIdInput = document.querySelector("input[name='id']");
        const currentVariantId = variantIdInput ? variantIdInput.value : null;
        const currentProductPrice = updateProductPriceByVariant(currentVariantId);
        const currentVariantName = updateProductNameByVariant(currentVariantId);

        // Cập nhật productPropertyElement bằng name của biến thể hiện tại
        productPropertyElement.textContent = currentVariantName || '';

        // console.log('Variant ID sau 200ms:', currentVariantId);
        // console.log('Giá biến thể sau 200ms:', currentProductPrice);
        // console.log('Tên biến thể sau 200ms:', currentVariantName);

        // Cập nhật trả góp nếu .bk-btn-installment đã có mặt
        updateInstallmentValue(currentProductPrice);

        // Cập nhật .bk-insta-content nếu đã có mặt
        updateInstaContentValue(currentProductPrice);
      }, 200);
    // }
  });



  // Sử dụng MutationObserver để theo dõi sự xuất hiện của .bk-btn-installment & .bk-insta-content
  const observer = new MutationObserver(function(mutationsList) {
    let installmentFound = false;
    let instaFound = false;

    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        const installmentButton = document.querySelector('.bk-btn-installment');
        if (installmentButton) {
          installmentButton.style.backgroundColor = "#eaf2ed";
          installmentButton.style.color = "#000";
          installmentButton.classList.add('custom-button'); 
          const variantIdInput = document.querySelector("input[name='id']");
          const currentVariantId = variantIdInput ? variantIdInput.value : null;
          const currentProductPrice = updateProductPriceByVariant(currentVariantId);
          updateInstallmentValue(currentProductPrice);
          installmentFound = true;
        }

        const instaButton = document.querySelector('.bk-btn-installment-amigo');
        if (instaButton) {
          instaButton.style.backgroundColor = "#eaf2ed";
          instaButton.style.color = "#000";
          instaButton.classList.add('custom-button'); 
          const variantIdInput = document.querySelector("input[name='id']");
          const currentVariantId = variantIdInput ? variantIdInput.value : null;
          const currentProductPrice = updateProductPriceByVariant(currentVariantId);
          updateInstaContentValue(currentProductPrice);
          instaFound = true;
        }
      }
    }

    // Ngắt quan sát nếu đã tìm thấy 1 trong 2, tránh loop
    if (installmentFound || instaFound) {
      observer.disconnect();
    }
  });

  // Quan sát sự thay đổi trong DOM
  observer.observe(document.body, { childList: true, subtree: true });
});
